module.exports = __webpack_public_path__ + "static/media/Assistance on Currency and ATM Location.8e3c6eac.png";